<template>
  <div class="nav">
    <div class="nav_box">
      <span>跨系统账号转移服务</span>
      <i
        class="return_btn"
        v-if="$parent.currentPage == 6 && returnShow"
        @click="$parent.currentPage--"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      returnShow: true
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    if (this.$parent.getParams().data) {
      this.returnShow = false;
    }
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
.nav {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  .nav_box {
    width: 7.5rem;
    height: 1.78rem;
    background: #3e73fe;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
    span {
      font-size: 0.34rem;
      color: #fff;
      margin-bottom: 0.26rem;
    }
    .return_btn {
      width: 0.22rem;
      height: 0.39rem;
      background: url('../../assets/return_icon.png');
      background-size: 100% 100%;
      position: absolute;
      bottom: 0.28rem;
      left: 0.3rem;
    }
  }
}
</style>